import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function ArrowRightUp({ idVariant = '', className }: Props) {
  return (
    <IconBase name="arrow-right-up" w={24} className={className}>
      <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z" fill="currentColor"/>
    </IconBase>
  )
}

export default ArrowRightUp
